import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDataAccelerationParams {
  targetIds: string[];
}

export class TurnOnDataAccelerationForViews extends Request<IDataAccelerationParams, IResult> {
  constructor(params: IDataAccelerationParams) {
    super('enableDataAccelerationForViews', params);
  }
}

export class TurnOffDataAccelerationForViews extends Request<IDataAccelerationParams, IResult> {
  constructor(params: IDataAccelerationParams) {
    super('disableDataAccelerationForViews', params);
  }
}
